import useAxios from 'hooks/useAxios'
import { Loader } from 'shared/components/Loader'
import React, { useEffect, useState } from 'react'
import { Accordion, Button } from 'semantic-ui-react'
import BrandSettingForm from './BrandSettingForm'
import usePermission from 'hooks/usePermission'
import WebFont from 'webfontloader'
import BrandDeleteButton from './BrandDeleteButton'
import constants from 'config/constants'

export const SURVEY_FONTS = [
  'Inter',
  'Lato',
  'Montserrat',
  'Open Sans',
  'Oswald',
  'Raleway',
  'Roboto',
  'Roboto Mono',
  'Ubuntu',
]

export const includeWeightOfFont = (font) =>
  `${font}:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900`

export default function BrandSettings({ enableCustomizeBranding, brands }) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [hasCustomCSS, setHasCustomCSS] = useState(false)
  const { fetch: updateBrand, loading } = useAxios({
    url: 'brand/brands/',
    method: 'put',
    skip: true,
  })
  const { hasPermission } = usePermission()

  function handleBrandTabChange(e, titleProps) {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index

    setActiveIndex(newIndex)
  }

  useEffect(() => {
    WebFont.load({
      google: {
        families: SURVEY_FONTS.map(includeWeightOfFont),
      },
    })
  }, [])

  if (!brands) {
    return <Loader withContainer />
  }

  const hasManageBrandsPermission = hasPermission(constants.permissions.manageBrands)
  return (
    <Accordion styled fluid>
      {brands.results.map((brand, index) => {
        const shouldShowSaveButton = activeIndex === index && hasManageBrandsPermission
        const disallowSavingCustomCSS = !enableCustomizeBranding && hasCustomCSS

        return (
          <React.Fragment key={brand.id}>
            <Accordion.Title
              active={activeIndex === index}
              index={index}
              onClick={handleBrandTabChange}
            >
              <div className="flex justify-between items-center">
                <div>
                  <i className="fas fa-caret-down icon" />
                  {brand.name}
                  {index === 0 && (
                    <label className="ml2 ui label !bg-green-lighter">Default brand</label>
                  )}
                </div>
                <div>
                  {shouldShowSaveButton && (
                    <div className="flex justify-between items-center">
                      <Button
                        primary
                        form={`brand-${brand.id}-form`}
                        type="submit"
                        disabled={disallowSavingCustomCSS || loading}
                        loading={loading}
                        onClick={(e) => e.stopPropagation()}
                      >
                        Update brand
                      </Button>
                      {index !== 0 && <BrandDeleteButton brandId={brand.id} />}
                    </div>
                  )}
                </div>
              </div>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === index}>
              <BrandSettingForm
                key={brand.id}
                brand={brand}
                updateBrand={updateBrand}
                enableCustomizeBranding={enableCustomizeBranding}
                isAccordionOpened={activeIndex === index}
                hasManageBrandsPermission={hasManageBrandsPermission}
                handleCustomCSSChange={setHasCustomCSS}
              />
            </Accordion.Content>
          </React.Fragment>
        )
      })}
    </Accordion>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/BrandSettings/index.js